import { VerifyStep } from '@/components/verify/types'
import { User } from '@/state/global'
import { verifyResend } from '@/utils/apis'

export const INVALID_AUTH_TOKEN_DESCRIPTION =
  'The provided password auth token is not valid. Please request a new token and try again.'

export type AuthErrorDeps = {
  onError?: (error: unknown) => void
  setSessionExpired: (v: boolean) => void
  openVerifyComponent: (v: boolean) => void
  setVerifyStep: (v: VerifyStep) => void
  user: User | null
}

export function isAuthFailure(error: unknown): boolean {
  const e = error as { name?: string; description?: string }
  if (e?.name === 'Unauthorized') return true
  if (e?.description === INVALID_AUTH_TOKEN_DESCRIPTION) return true
  return false
}

export function isUnauthorizedError(error: any): boolean {
  if (
    error?.name === 'Unauthorized' &&
    error?.default?.length &&
    error?.default?.length > 0 &&
    error?.default?.[0] === 'phone_verification_required'
  )
    return true
  return false
}

export async function handleAuthError(error: any, deps: AuthErrorDeps): Promise<boolean> {
  if (error?.description === INVALID_AUTH_TOKEN_DESCRIPTION) {
    deps.onError?.(error)
    localStorage.removeItem('user')
    localStorage.removeItem('status')
    deps.setSessionExpired(true)
    deps.openVerifyComponent(true)
    return true
  }
  if (isUnauthorizedError(error)) {
    deps.onError?.(error)

    if (!error?._verifyResendHandled) {
      try {
        await verifyResend(deps.user)
      } catch {}
    }
    deps.setVerifyStep(VerifyStep.Code)
    deps.openVerifyComponent(true)
    return true
  }
  return false
}
